import React, { useEffect, useState } from "react";
import cn from "classnames";
import style from "./style.module.scss";
import CustomSelect from "../../custom/custom-select";
import CustomButton from "../../custom/custom-button/CustomButton";
import FilterDatePicker from "../../custom/сustom-filter-date/FilterDatePicker";
import CloseIconNew from "../../shared/icons/CloseIconNew";
import { ORDER_STATUSES } from "../../../mock";
import CustomInput from "../../custom/custom-input/CustomInput";
import { useTranslation } from "react-i18next";

const OrderFilter = ({
  orderNumber,
  setOrderNumber,
  cities,
  cityFrom,
  setCityFrom,
  cityTo,
  setCityTo,
  loadingDate,
  setLoadingDate,
  unloadingDate,
  setUnloadingDate,
  selectedStatus,
  setSelectedStatus,
  statusActive,
  isShowStatus = true,
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const statusFromUrl = params.get("status");
    if (statusFromUrl) {
      setActiveTab(statusFromUrl);
    } else if (window.location.pathname === "/main") {
      setActiveTab("all");
    }
  }, [statusActive]);

  const statusOptions = Object.entries(ORDER_STATUSES).map(([key, value]) => ({
    value: key,
    name: value,
  }));

  const handleReset = () => {
    setOrderNumber("");
    setCityFrom("");
    setCityTo("");
    setLoadingDate("");
    setUnloadingDate("");
    setSelectedStatus("");
  };

  return (
    <div className={cn(style.wrapper)}>
      <div className={cn(style.filter__container)} style={{ width: "150px" }}>
        <CustomInput
          labelText={t('orderFilter.orderLabel')}
          placeholder={t('orderFilter.orderPlaceholder')}
          prefixStart={<span>№</span>}
          inputType="number"
          value={orderNumber}
          onChangeValue={setOrderNumber}
          isBgGray
        />
      </div>
      <div className={cn(style.filter__container)}>
        <CustomSelect
          labelText={t('orderFilter.cityLabel')}
          placeholder={t('orderFilter.cityFromPlaceholder')}
          options={cities}
          defaultValue={cityFrom}
          onSubmit={(item) => {
            setCityFrom(item);
          }}
          returnObject
        />
        <CustomSelect
          labelText={t('orderFilter.cityLabel')}
          placeholder={t('orderFilter.cityToPlaceholder')}
          options={cities}
          defaultValue={cityTo}
          onSubmit={(item) => {
            setCityTo(item);
          }}
          returnObject
        />
      </div>
      <div className={cn(style.filter__container)}>
        <FilterDatePicker
          isEditable
          isMobile
          labelText={t('orderFilter.loadingDateLabel')}
          placeholderText={t('orderFilter.datePlaceholder')}
          date={loadingDate}
          setDate={setLoadingDate}
          IconStart={<CloseIconNew />}
        />

        <FilterDatePicker
          isEditable
          isMobile
          minDate={loadingDate}
          labelText={t('orderFilter.unloadingDateLabel')}
          placeholderText={t('orderFilter.datePlaceholder')}
          date={unloadingDate}
          setDate={setUnloadingDate}
        />
      </div>

      {isShowStatus &&
        <div className={cn(style.filter__container)}>
          <CustomSelect
            labelText={t('orderFilter.statusLabel')}
            placeholder={t('orderFilter.statusPlaceholder')}
            options={statusOptions}
            defaultValue={activeTab !== "all" ? "" : selectedStatus}
            isDisabled={activeTab !== "all"}
            returnObject
            onSubmit={(item) => {
              setSelectedStatus(item);
            }}
          />
        </div>
      }
      <div className={cn(style.filter__container)}>
        <CustomButton text={t('orderFilter.resetButton')} isUnderline onClick={handleReset} />
      </div>
    </div>
  );
};

export default OrderFilter;
